import React, { Fragment, useEffect, useState } from "react";
import { NavLink as RouterNavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import dolLogo from "../assets/dol-logo.png";


import { useAuth0 } from "@auth0/auth0-react";

import {
    Collapse,
    Container,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    Button,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";

const NavBarDesktop = () => {

    // State to hold the retrieved object
    //const [devices, setData] = useState(null);
    const { details } = useSelector(state => state.details);
    const isAdmin = useSelector((state) => state.user.isAdmin);
    const [deviceStatus, setDeviceStatus] = useState(null)

    console.log(details)
    const [isOpen, setIsOpen] = useState(false);
    const {
        user,
        isAuthenticated,
        loginWithRedirect,
        logout,
    } = useAuth0();
    const toggle = () => setIsOpen(!isOpen);

    const logoutWithRedirect = () =>
        logout({
            logoutParams: {
                returnTo: window.location.origin,
            }
        });



    return (
        <div className="nav-container h-100">
            <div className="shadow-[rgba(50,_50,_105,_0.15)_0px_2px_5px_0px,_rgba(0,_0,_0,_0.05)_0px_1px_1px_0px] absolute left-0 top-0 z-1 flex h-100 w-96 flex-col overflow-y-hidden bg-white duration-300 ease-linear dark:bg-boxdark md:static md:translate-x-0 -translate-x-full">
                <div className="flex items-center justify-between gap-2 px-6 py-4 md:py-6.5">
                    <a className="">
                        <img className="w-36 mt-4" src={dolLogo} alt="dol-sensors logo"></img>
                    </a>
                </div>
                <Nav vertical className="h-full">
                    {isAuthenticated && (
                        <NavItem>
                            <NavLink
                                className="group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-dol-blue duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 false"
                                tag={RouterNavLink}
                                to="/dashboard"
                                end
                            ><svg className="fill-current" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.10322 0.956299H2.53135C1.5751 0.956299 0.787598 1.7438 0.787598 2.70005V6.27192C0.787598 7.22817 1.5751 8.01567 2.53135 8.01567H6.10322C7.05947 8.01567 7.84697 7.22817 7.84697 6.27192V2.72817C7.8751 1.7438 7.0876 0.956299 6.10322 0.956299ZM6.60947 6.30005C6.60947 6.5813 6.38447 6.8063 6.10322 6.8063H2.53135C2.2501 6.8063 2.0251 6.5813 2.0251 6.30005V2.72817C2.0251 2.44692 2.2501 2.22192 2.53135 2.22192H6.10322C6.38447 2.22192 6.60947 2.44692 6.60947 2.72817V6.30005Z" fill=""></path><path d="M15.4689 0.956299H11.8971C10.9408 0.956299 10.1533 1.7438 10.1533 2.70005V6.27192C10.1533 7.22817 10.9408 8.01567 11.8971 8.01567H15.4689C16.4252 8.01567 17.2127 7.22817 17.2127 6.27192V2.72817C17.2127 1.7438 16.4252 0.956299 15.4689 0.956299ZM15.9752 6.30005C15.9752 6.5813 15.7502 6.8063 15.4689 6.8063H11.8971C11.6158 6.8063 11.3908 6.5813 11.3908 6.30005V2.72817C11.3908 2.44692 11.6158 2.22192 11.8971 2.22192H15.4689C15.7502 2.22192 15.9752 2.44692 15.9752 2.72817V6.30005Z" fill=""></path><path d="M6.10322 9.92822H2.53135C1.5751 9.92822 0.787598 10.7157 0.787598 11.672V15.2438C0.787598 16.2001 1.5751 16.9876 2.53135 16.9876H6.10322C7.05947 16.9876 7.84697 16.2001 7.84697 15.2438V11.7001C7.8751 10.7157 7.0876 9.92822 6.10322 9.92822ZM6.60947 15.272C6.60947 15.5532 6.38447 15.7782 6.10322 15.7782H2.53135C2.2501 15.7782 2.0251 15.5532 2.0251 15.272V11.7001C2.0251 11.4188 2.2501 11.1938 2.53135 11.1938H6.10322C6.38447 11.1938 6.60947 11.4188 6.60947 11.7001V15.272Z" fill=""></path><path d="M15.4689 9.92822H11.8971C10.9408 9.92822 10.1533 10.7157 10.1533 11.672V15.2438C10.1533 16.2001 10.9408 16.9876 11.8971 16.9876H15.4689C16.4252 16.9876 17.2127 16.2001 17.2127 15.2438V11.7001C17.2127 10.7157 16.4252 9.92822 15.4689 9.92822ZM15.9752 15.272C15.9752 15.5532 15.7502 15.7782 15.4689 15.7782H11.8971C11.6158 15.7782 11.3908 15.5532 11.3908 15.272V11.7001C11.3908 11.4188 11.6158 11.1938 11.8971 11.1938H15.4689C15.7502 11.1938 15.9752 11.4188 15.9752 11.7001V15.272Z" fill=""></path></svg>
                                Dashboard
                            </NavLink>
                            <NavLink
                                className="group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-dol-blue duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 false"
                                tag={RouterNavLink}
                                to="/export"
                                end
                            ><svg className="w-6 h-6 text-gray-800 dark:text-dol-blue" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 10V4a1 1 0 0 0-1-1H9.914a1 1 0 0 0-.707.293L5.293 7.207A1 1 0 0 0 5 7.914V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2M10 3v4a1 1 0 0 1-1 1H5m5 6h9m0 0-2-2m2 2-2 2" />
                                </svg>
                                Export Data
                            </NavLink>
                        </NavItem>
                    )}
                    {isAuthenticated && details && (
                        <div>
                            <h3 className="group opacity-80 relative flex items-center gap-2.5 rounded-sm py-3 px-4 font-medium text-dol-blue duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 false">
                                DEVICES
                            </h3>
                            {details.map((device, key) => (
                                <NavItem key={key}>
                                    <NavLink
                                        className="group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-dol-blue duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 false"
                                        tag={RouterNavLink}
                                        to={`/devices/${device.mac}`}
                                        state={device}
                                    >
                                        {console.log(device.deviceName)}
                                        {device.deviceName}
                                    </NavLink>
                                    {device.sensors !== 0 && device.deviceType !== "IDOL65" && (
                                        device.sensors.map((sensor, key) => (
                                            <NavLink
                                                className="group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-dol-blue duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 false"
                                                tag={RouterNavLink}
                                                key={key}
                                                state={{ item: sensor, mac: device.mac, deviceStatus: deviceStatus }}
                                                to={`/devices/${device.mac}/sensors/${sensor.devEui}`}
                                            >
                                                <div className="mx-4">
                                                    {sensor.name}
                                                </div>
                                            </NavLink>
                                        ))

                                    )}
                                    {device.wiredSensors !== 0 && device.deviceType !== "IDOL65" && (
                                        device.wiredSensors.map((wiredSensor, key) => (
                                            <NavLink
                                                className="group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-dol-blue duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 false"
                                                tag={RouterNavLink}
                                                key={key}
                                                state={{ item: wiredSensor, mac: device.mac, deviceStatus: deviceStatus }}
                                                to={`/devices/${device.mac}/wired-sensors/wired-sensor-${wiredSensor.port}`}
                                            >
                                                {console.log(wiredSensor.port)}
                                                <div className="mx-4">
                                                    wired-sensor-{wiredSensor.port}
                                                </div>
                                            </NavLink>
                                        ))

                                    )}
                                </NavItem>
                            ))}
                        </div>
                    )}
                    {isAuthenticated && isAdmin && (
                    <div>
                        <h3 className="group opacity-80 relative flex items-center gap-2.5 rounded-sm py-3 px-4 font-medium text-dol-blue duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 false">
                            ADMIN
                        </h3>
                        <NavItem>
                            <NavLink
                                className="group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-dol-blue duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 false"
                                tag={RouterNavLink}
                                to="/admin/users"
                                end
                            ><svg className="w-6 h-6 text-gray-800 dark:text-dol-blue" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="9" cy="6" r="4" stroke="#1C274C" strokeWidth="1.5"></circle> <path d="M15 9C16.6569 9 18 7.65685 18 6C18 4.34315 16.6569 3 15 3" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round"></path> <ellipse cx="9" cy="17" rx="7" ry="4" stroke="#1C274C" strokeWidth="1.5"></ellipse> <path d="M18 14C19.7542 14.3847 21 15.3589 21 16.5C21 17.5293 19.9863 18.4229 18.5 18.8704" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round"></path> </g></svg>
                                Users
                            </NavLink>
                        </NavItem>
                    </div>
                )}
                    {isAuthenticated && (
                        <NavItem className="mt-auto">
                            <div className="group relative flex items-center gap-2.5 rounded-sm py-4 px-4 font-medium text-dol-blue duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 false">
                                <Link to={"/profile"}>
                                    <img
                                        src={user.picture}
                                        alt="Profile"
                                        className="nav-user-profile rounded-circle"
                                        width="50"
                                    />
                                </Link>
                                <RouterNavLink onClick={() => logoutWithRedirect()}>
                                    Log out
                                </RouterNavLink>
                            </div>
                        </NavItem>
                    )}
                </Nav>
            </div>
        </div>
    );
};

export default NavBarDesktop;
